"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _dataMapExport = require("./dataMapExport.constant");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // @flow
var INIT_STATE = {
  download: null,
  downloadSurvey: null,
  downloadRecipient: null,
  loading: false
};
var dataMapExport = function dataMapExport() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INIT_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _dataMapExport.actionTypes.DOWNLOAD:
      return _objectSpread(_objectSpread({}, state), {}, {
        download: state.download
      });
    case _dataMapExport.actionTypes.DOWNLOAD_SURVEY:
      return _objectSpread(_objectSpread({}, state), {}, {
        downloadSurvey: state.downloadSurvey
      });
    case _dataMapExport.actionTypes.DOWNLOAD_RECIPIENT:
      return _objectSpread(_objectSpread({}, state), {}, {
        downloadRecipient: state.downloadRecipient
      });
    case _dataMapExport.actionTypes.SUCCESS:
      switch (action.payload.actionType) {
        case _dataMapExport.actionTypes.DOWNLOAD:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            download: action.payload.data
          });
        case _dataMapExport.actionTypes.DOWNLOAD_SURVEY:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            downloadSurvey: action.payload.data
          });
        case _dataMapExport.actionTypes.DOWNLOAD_RECIPIENT:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            downloadRecipient: action.payload.data
          });
        default:
          return _objectSpread({}, state);
      }
    case _dataMapExport.actionTypes.ERROR:
      switch (action.payload.actionType) {
        case _dataMapExport.actionTypes.DOWNLOAD:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            download: action.payload.error
          });
        case _dataMapExport.actionTypes.DOWNLOAD_SURVEY:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            downloadSurvey: action.payload.error
          });
        case _dataMapExport.actionTypes.DOWNLOAD_RECIPIENT:
          return _objectSpread(_objectSpread({}, state), {}, {
            loading: false,
            downloadRecipient: action.payload.error
          });
        default:
          return _objectSpread({}, state);
      }
    case _dataMapExport.actionTypes.RESET:
      return _objectSpread({}, INIT_STATE);
    default:
      return _objectSpread({}, state);
  }
};
var _default = dataMapExport;
exports.default = _default;